import helper from './helper'

export default {
  async getAll(mediaId, episodeId) {
    if (episodeId) {
      return await helper.get(
        `/api/media-assets?mediaId=${mediaId}&episodeId=${episodeId}`
      )
    }
    return await helper.get(`/api/media-assets?mediaId=${mediaId}`)
  },
  async create(asset) {
    return await helper.post(`/api/media-assets`, asset)
  },
  async remove(asset) {
    return await helper.delete(`/api/media-assets/${asset.id}`)
  }
}
